import { render, staticRenderFns } from "./ResubmitForm.vue?vue&type=template&id=1fda5ada&"
import script from "./ResubmitForm.vue?vue&type=script&lang=js&"
export * from "./ResubmitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports